import { render, staticRenderFns } from "./PublicationLog.vue?vue&type=template&id=6bf5e11a&"
import script from "./PublicationLog.vue?vue&type=script&lang=ts&"
export * from "./PublicationLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports